import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { ManufacturerFilterSettingsModel, ManufacturerAdminModel } from "../models/manufacturer";
import AuthService from './authService';

class ManufacturerService {
	authService = new AuthService();

	constructor() {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Authorization: `Bearer ${this.authService.getToken()}`,
			Pragma: 'no-cache'
		}
	}

	getAllManufacturers(from: number, numberOfRows: number, settings: ManufacturerFilterSettingsModel) {
		return axios({
			url: `adminManufacturer/getAll/${from}/${numberOfRows}`,
			method: 'post', headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(settings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getManufacturer(id: number) {
		return axios({
			url: `adminManufacturer/getById/${id}`,
			method: 'get'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	addManufacturer(medicine: ManufacturerAdminModel) {
		return axios({
			url: `adminManufacturer/createManufacturer`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicine)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	editManufacturer(id: number, medicine: ManufacturerAdminModel) {
		return axios({
			url: `adminManufacturer/updateManufacturer/${id}`,
			method: 'put',
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			},
			data: JSON.stringify(medicine)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	deleteManufacturer(id: number) {
		return axios({
			url: `adminManufacturer/deleteManufacturer/${id}`,
			method: 'delete'
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDropdownList() {
		return axios({
			url: `adminManufacturer/getDropdownList/`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}
}

export default ManufacturerService;
